import { c as _c } from "react/compiler-runtime";
import { IcoDotsHorizontal24 } from '@onefootprint/icons';
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { Dropdown, useToast } from '@onefootprint/ui';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
type FooterActionsProps = {
  config?: OnboardingSessionConfig;
  className?: string;
  defaultOpen?: boolean;
};
const handleRedirect = (url: string) => {
  window.open(url, '_blank');
};
const FooterActions = t0 => {
  const $ = _c(56);
  const {
    config,
    className,
    defaultOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "global.components.footer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  const {
    toast
  } = useToast();
  const hasSupportEmail = config?.supportEmail;
  const hasSupportPhone = config?.supportPhone;
  const hasSupportWebsite = config?.supportWebsite;
  const shouldShowSupportLinks = hasSupportEmail || hasSupportPhone || hasSupportWebsite;
  const toggleLanguage = _temp;
  let t2;
  if ($[1] !== t || $[2] !== toast) {
    t2 = email => {
      if (email) {
        window.open(`mailto:${email}`, "_blank");
      } else {
        toast({
          title: t(_temp2),
          description: t(_temp3)
        });
      }
    };
    $[1] = t;
    $[2] = toast;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sendEmail = t2;
  let t3;
  if ($[4] !== t || $[5] !== toast) {
    t3 = phoneNumber => {
      if (phoneNumber) {
        navigator.clipboard.writeText(phoneNumber);
        toast({
          title: t(_temp4),
          description: t(_temp5)
        });
      } else {
        toast({
          title: t(_temp6),
          description: t(_temp7)
        });
      }
    };
    $[4] = t;
    $[5] = toast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const copyToClipboard = t3;
  let t4;
  if ($[7] !== t || $[8] !== toast) {
    t4 = link => {
      if (link) {
        window.open(link, "_blank");
      } else {
        toast({
          title: t(_temp8),
          description: t(_temp9)
        });
      }
    };
    $[7] = t;
    $[8] = toast;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const openLink = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Dropdown.Trigger><IcoDotsHorizontal24 color="primary" /></Dropdown.Trigger>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== config?.privacyPolicyUrl) {
    t6 = () => handleRedirect(config?.privacyPolicyUrl ?? "https://onefootprint.com/privacy-policy");
    $[11] = config?.privacyPolicyUrl;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp10);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Dropdown.Item onClick={t6} size="compact">{t7}</Dropdown.Item>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== config?.termsOfServiceUrl) {
    t9 = () => handleRedirect(config?.termsOfServiceUrl ?? "https://onefootprint.com/terms-of-service");
    $[18] = config?.termsOfServiceUrl;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp11);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <Dropdown.Item onClick={t9} size="compact">{t10}</Dropdown.Item>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t8) {
    t12 = <Dropdown.Group>{t8}{t11}</Dropdown.Group>;
    $[25] = t11;
    $[26] = t8;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Dropdown.Divider />;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== config?.supportEmail || $[30] !== config?.supportPhone || $[31] !== config?.supportWebsite || $[32] !== copyToClipboard || $[33] !== hasSupportEmail || $[34] !== hasSupportPhone || $[35] !== hasSupportWebsite || $[36] !== openLink || $[37] !== sendEmail || $[38] !== shouldShowSupportLinks || $[39] !== t) {
    t14 = shouldShowSupportLinks && <><Dropdown.Group>{hasSupportEmail && <Dropdown.Item onClick={() => sendEmail(config?.supportEmail)} size="compact">{t(_temp12)}</Dropdown.Item>}{hasSupportPhone && <Dropdown.Item onClick={() => copyToClipboard(config?.supportPhone)} size="compact">{t(_temp13)}</Dropdown.Item>}{hasSupportWebsite && <Dropdown.Item onClick={() => openLink(config?.supportWebsite)} size="compact">{t(_temp14)}</Dropdown.Item>}</Dropdown.Group><Dropdown.Divider /></>;
    $[29] = config?.supportEmail;
    $[30] = config?.supportPhone;
    $[31] = config?.supportWebsite;
    $[32] = copyToClipboard;
    $[33] = hasSupportEmail;
    $[34] = hasSupportPhone;
    $[35] = hasSupportWebsite;
    $[36] = openLink;
    $[37] = sendEmail;
    $[38] = shouldShowSupportLinks;
    $[39] = t;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t) {
    t15 = t(_temp15);
    $[41] = t;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== t15) {
    t16 = <span className="text-body-2 text-primary">{t15}</span>;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-body-2 text-primary">{i18n.language === "en" ? "Spanish" : "Ingl\xE9s"}</span>;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== t16) {
    t18 = <Dropdown.Group><Dropdown.Item onClick={toggleLanguage} size="compact"><div className="flex items-center justify-between">{t16}{t17}</div></Dropdown.Item></Dropdown.Group>;
    $[46] = t16;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== className || $[49] !== t12 || $[50] !== t14 || $[51] !== t18) {
    t19 = <Dropdown.Portal><Dropdown.Content align="end" className={className}>{t12}{t13}{t14}{t18}</Dropdown.Content></Dropdown.Portal>;
    $[48] = className;
    $[49] = t12;
    $[50] = t14;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== defaultOpen || $[54] !== t19) {
    t20 = <Dropdown.Root defaultOpen={defaultOpen}>{t5}{t19}</Dropdown.Root>;
    $[53] = defaultOpen;
    $[54] = t19;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  return t20;
};
export default FooterActions;
function _temp() {
  const currentLang = i18n.language;
  const newLang = currentLang === "en" ? "es" : "en";
  i18n.changeLanguage(newLang);
}
function _temp2($) {
  return $.support.email["toast-error"].title;
}
function _temp3($_0) {
  return $_0.support.email["toast-error"].description;
}
function _temp4($_1) {
  return $_1.support.phone["toast-success"].title;
}
function _temp5($_2) {
  return $_2.support.phone["toast-success"].description;
}
function _temp6($_3) {
  return $_3.support.phone["toast-error"].title;
}
function _temp7($_4) {
  return $_4.support.phone["toast-error"].description;
}
function _temp8($_5) {
  return $_5.support.website["toast-error"].title;
}
function _temp9($_6) {
  return $_6.support.website["toast-error"].description;
}
function _temp10($_7) {
  return $_7.privacy;
}
function _temp11($_8) {
  return $_8.terms;
}
function _temp12($_9) {
  return $_9.support.email.label;
}
function _temp13($_10) {
  return $_10.support.phone.label;
}
function _temp14($_11) {
  return $_11.support.website.label;
}
function _temp15($_12) {
  return $_12["change-language"];
}